import { render } from "./CommunityPublications.vue.js?vue&type=template&id=4bf139d4!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommunityPublications.vue?vue&type=template&id=4bf139d4"
import script from "./CommunityPublications.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommunityPublications.vue?vue&type=script&lang=js"
export * from "./CommunityPublications.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommunityPublications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/community/CommunityPublications.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4bf139d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4bf139d4', __exports__)) {
    api.reload('4bf139d4', __exports__)
  }
  
  module.hot.accept("./CommunityPublications.vue.js?vue&type=template&id=4bf139d4!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CommunityPublications.vue?vue&type=template&id=4bf139d4", () => {
    api.rerender('4bf139d4', render)
  })

}


export default __exports__